/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import HeroHeader from 'src/components/shared/modules/heroHeader/HeroHeader'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store/store'
import {
  AboutTeamContent,
  ChangeMakerContent,
  contentType,
  JoinUsContent,
} from 'src/types/components/shared/atom'
import useStyles from 'src/styles/pages/meetTheTeam/Style'
import AboutTeam from 'src/components/pages/meetTeam/aboutTeam/AboutTeam'
import JoinUs from 'src/components/pages/meetTeam/joinUs/JoinUs'
import ChangeMaker from 'src/components/pages/meetTeam/changeMaker/ChangeMaker'
import Skeleton from 'src/components/shared/modules/skeleton'
import HeadTag from 'src/components/layout/head'
import { useRouter } from 'next/router'
import { apiFetch } from '../../service/api.service';

interface IProps {
  data: any
  isLoading: boolean
}
const MeetTheTeam: React.FC<IProps> = ({ data, isLoading }) => {
  const { classes } = useStyles()
  const zenMode = useSelector((state: RootState) => state.zenModeState.zenMode)
  const [headerContent, setHeaderContent] = useState<contentType>()
  const [aboutTeamContent, setAboutTeamContent] = useState<AboutTeamContent>()
  const [joinUsContent, setJoinUsContent] = useState<JoinUsContent>()
  const [changeMakerContent, setChangeMakerContent] =
    useState<ChangeMakerContent>()
  // const { data, isLoading } = useGetPageByNameQuery('meetTheTeam')
  const router = useRouter()
  useEffect(() => {
    if (data && data.data.length > 0) {
      const { heroHeader, aboutTeamSection, changeMakerSection, joinUs } =
        data.data[0].attributes
      //extracting heroHeader from data
      if (heroHeader) {
        const heroHeaderContent: contentType = {
          content: {
            secondary: {
              content: heroHeader.secondaryText,
              variant: 'h3',
              type: 'secondary',
            },
            primary: {
              content: heroHeader.primaryText,
              variant: 'h1',
              type: 'primary',
            },
            tertiary: {
              content: heroHeader.tertiaryText,
              variant: 'subtitle1',
              type: 'tertiary',
            },
          },
        }
        setHeaderContent(heroHeaderContent)
      }

      //extracting aboutTeamSection from data
      if (aboutTeamSection) {
        const aboutTeamContent: AboutTeamContent = {
          cardData: aboutTeamSection.aboutTeamCard.map((curr: any) => {
            return {
              img: curr.image.data.attributes.url,
              name: curr.name,
              designation: curr.designation,
              description: curr.description,
            }
          }),

          text: aboutTeamSection.heading,
        }
        setAboutTeamContent(aboutTeamContent)
      }

      //extracting joinUs from data
      if (joinUs) {
        const joinUsContent: JoinUsContent = {
          heading: joinUs.heading,
          text: joinUs.text,
          btnData: {
            content: joinUs.button.content,
            href: joinUs.button.href ? joinUs.button.href : '#',
          },
        }
        setJoinUsContent(joinUsContent)
      }

      //extracting changeMakerSection from data
      if (changeMakerSection) {
        const changeMakerContent: ChangeMakerContent = {
          logoImg:
            changeMakerSection.changeMakerCard.dtlLogo.data.attributes.url,
          changeMakerBg:
            changeMakerSection.changeMakerCard.image.data.attributes.url,
          logoText: changeMakerSection.changeMakerCard.dtlLogoText,
          logoPara: changeMakerSection.changeMakerCard.imgCaption,
          rightHeading: changeMakerSection.heading,
          rightSubHeading: changeMakerSection.subHeading,
          rightPara: changeMakerSection.text,
        }
        setChangeMakerContent(changeMakerContent)
      }
    } else if (data && data.data.length == 0 && !isLoading) {
      router.push('/404')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <>
      <HeadTag
        title={data?.data[0]?.attributes.metaTitle}
        description={data?.data[0]?.attributes.metaDescription}
      />
      {headerContent ? (
        <HeroHeader searchField={false} heroContent={headerContent} />
      ) : (
        <Skeleton />
      )}
      <Grid className={classes.rootContainer}>
        {aboutTeamContent ? (
          <AboutTeam zenMode={zenMode} content={aboutTeamContent} />
        ) : (
          ''
        )}

        {joinUsContent ? (
          <JoinUs content={joinUsContent} zenMode={zenMode} />
        ) : (
          ''
        )}

        {changeMakerContent ? (
          <ChangeMaker zenMode={zenMode} content={changeMakerContent} />
        ) : (
          ''
        )}
      </Grid>
    </>
  )
}

// This gets called on every request
export async function getServerSideProps() {
  // Fetch data from external API
  const baseURL =
    process.env.NEXT_PUBLIC_BACKEND_URL ||
    'https://strapi-beta.ditchthelabel.org'
  const endPoint =
    process.env.NEXT_PUBLIC_SITE_LANGUAGE === 'en'
      ? `/api/article-schemas?filters[name][$eq]=meetTheTeam&populate=deep`
      : `/api/article-schemas?filters[name][$eq]=mx-meetTheTeam&populate=deep&locale=es-MX`
  const url = baseURL + endPoint
  let isLoading = true

  const data = await apiFetch(url)

  isLoading = false

  // Pass data to the page via props
  return { props: { data, isLoading } }
}

export default MeetTheTeam
